import {all, fork} from 'redux-saga/effects';
import seekSaga from './actions/seek';
import dataseekSaga from './actions/dataset'

export default function* root() {
  yield all([
    fork(dataseekSaga),
    fork(seekSaga),
  ]);
}